import { useMediaQuery } from "react-responsive";

const DesktopMinWidth = 1280; // 992
const TabletMaxWidth = 1279; // 991
const TabletMinWidth = 768; // 768
const MobileMaxWidth = 767; // 767

export { DesktopMinWidth, TabletMaxWidth, TabletMinWidth, MobileMaxWidth };
